import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Form, Input, Switch } from 'antd';
import { MenuProvider } from '../../../services/exports/Constants';
import ImportMenu from '../../../components/menu/ImportMenu';

export default function CompanyProviders({ data, onChange }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:Company:AddCompanyModal' });

  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const providers = useMemo(
    () => [
      {
        is_supported: (serviceProvider?.regional_config?.supported_menu_providers ?? []).includes(
          MenuProvider.Lieferando,
        ),
        renderSettings: () =>
          (data.sync_lieferando_brand || data.sync_lieferando_menu) && (
            <div className="mt-md">
              <Form.Item label={t('form.lieferando_url.label')}>
                <Input
                  value={data.lieferando_url ?? ''}
                  onChange={(e) => onChange('lieferando_url', e.target.value)}
                  placeholder={t('form.lieferando_url.placeholder')}
                />
              </Form.Item>
            </div>
          ),
        renderToggles: () => (
          <Flex>
            <Switch
              checked={data.sync_lieferando_brand}
              onChange={(checked) => onChange('sync_lieferando_brand', checked)}
              id="sync-lieferando-brand"
            />
            <label htmlFor="sync-lieferando-brand" className="ml-xs my-auto">
              {t('form.sync_lieferando_brand.label')}
            </label>
          </Flex>
        ),
      },
      {
        id: MenuProvider.Wolt,
        is_supported: true,
        renderSettings: () =>
          data.import_menu && (
            <ImportMenu
              data={{
                provider: data.menu_provider,
                provider_id: data.menu_provider_id,
              }}
              update={(field, value) => onChange(`menu_${field}`, value)}
              nullable
              className="mt-md"
            />
          ),
        renderToggles: () => (
          <Flex className="mt-lg">
            <Switch
              checked={data.import_menu}
              onChange={(checked) => onChange('import_menu', checked)}
              id="import-menu"
            />
            <label htmlFor="import-menu" className="ml-xs my-auto">
              {t('form.import_menu.label')}
            </label>
          </Flex>
        ),
      },
    ],
    [data, serviceProvider],
  );

  return (
    <div>
      <h3 className="mb-lg">{t('additional_options.title')}</h3>
      {providers.map(
        (item) =>
          item.is_supported && (
            <React.Fragment key={`menu-provider-${item.id}`}>
              {item.renderToggles()}
              {item.renderSettings()}
            </React.Fragment>
          ),
      )}
    </div>
  );
}
